import React, { useEffect, useState } from "react";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
  Paper, Switch, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TextField, Typography, Tooltip
} from "@mui/material";
import { MdAdd, MdEdit, MdDelete } from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import { base_url } from "../../../utils/api-routes/index";

const API = base_url + "api/sanatani-location";
const empty = { city: "", cityHindi: "", state: "", icon: "🛕", temple: "", templeHindi: "", sortOrder: 0 };

const SanataniLocations = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(API + "/admin/list");
      if (res.data.success) setList(res.data.data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const handleOpen = (item = null) => {
    if (item) {
      setForm({
        city: item.city, cityHindi: item.cityHindi || "", state: item.state,
        icon: item.icon || "🛕", temple: item.temple || "", templeHindi: item.templeHindi || "",
        sortOrder: item.sortOrder || 0,
      });
      setEditId(item._id);
    } else {
      setForm(empty); setEditId(null);
    }
    setOpen(true);
  };

  const handleSave = async () => {
    if (!form.city || !form.state) {
      return Swal.fire("Error", "City and State are required", "error");
    }
    try {
      if (editId) {
        await axios.put(`${API}/${editId}`, form);
      } else {
        await axios.post(`${API}/create`, form);
      }
      Swal.fire("Success", "Saved", "success");
      setOpen(false);
      load();
    } catch (e) {
      Swal.fire("Error", e.response?.data?.message || e.message, "error");
    }
  };

  const handleDelete = async (id) => {
    const c = await Swal.fire({ title: "Delete?", icon: "warning", showCancelButton: true, confirmButtonColor: "#d33" });
    if (!c.isConfirmed) return;
    await axios.delete(`${API}/${id}`);
    load();
  };

  const handleToggle = async (id) => {
    await axios.put(`${API}/${id}/toggle`);
    load();
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h5">Sanatani Sadan Locations</Typography>
        <Button variant="contained" startIcon={<MdAdd />} onClick={() => handleOpen()} sx={{ bgcolor: "#FF6B00" }}>
          Add Location
        </Button>
      </Box>
      <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
        Locations added here appear as cards on the Sanatani Sadan home in user app and as state/city dropdown options for vendors when adding a property.
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ bgcolor: "#f5f5f5" }}>
            <TableRow>
              <TableCell>Icon</TableCell>
              <TableCell>City</TableCell>
              <TableCell>City (Hindi)</TableCell>
              <TableCell>State</TableCell>
              <TableCell>Temple</TableCell>
              <TableCell>Sort</TableCell>
              <TableCell>Active</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={8} align="center">Loading...</TableCell></TableRow>
            ) : list.length === 0 ? (
              <TableRow><TableCell colSpan={8} align="center">No locations</TableCell></TableRow>
            ) : list.map((item) => (
              <TableRow key={item._id}>
                <TableCell>{item.icon}</TableCell>
                <TableCell>{item.city}</TableCell>
                <TableCell>{item.cityHindi}</TableCell>
                <TableCell>{item.state}</TableCell>
                <TableCell>{item.temple}</TableCell>
                <TableCell>{item.sortOrder}</TableCell>
                <TableCell>
                  <Switch checked={item.isActive} onChange={() => handleToggle(item._id)} />
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Edit"><IconButton onClick={() => handleOpen(item)}><MdEdit color="#FF6B00" /></IconButton></Tooltip>
                  <Tooltip title="Delete"><IconButton onClick={() => handleDelete(item._id)}><MdDelete color="#d33" /></IconButton></Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{editId ? "Edit Location" : "Add Location"}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, mt: 1 }}>
            <TextField label="State *" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} fullWidth />
            <TextField label="City *" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} fullWidth />
            <TextField label="City (Hindi)" value={form.cityHindi} onChange={(e) => setForm({ ...form, cityHindi: e.target.value })} fullWidth />
            <TextField label="Icon (emoji)" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })} fullWidth />
            <TextField label="Temple Name" value={form.temple} onChange={(e) => setForm({ ...form, temple: e.target.value })} fullWidth />
            <TextField label="Temple (Hindi)" value={form.templeHindi} onChange={(e) => setForm({ ...form, templeHindi: e.target.value })} fullWidth />
            <TextField label="Sort Order" type="number" value={form.sortOrder} onChange={(e) => setForm({ ...form, sortOrder: e.target.value })} fullWidth />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave} sx={{ bgcolor: "#FF6B00" }}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SanataniLocations;
